import { AppBar, Box, Toolbar } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => (
  <AppBar position="static" className="header">
    <Toolbar>
      <Box className="header-content">
        <Link to="/" style={{ display: 'inline-block' }}>
          <img
            src="/clips_banner.svg"
            alt="Feed.fm Clips Banner"
            className="header-banner"
          />
        </Link>
      </Box>
    </Toolbar>
  </AppBar>
);

export default Header;
